import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import { TableCell, TableRow, Tooltip } from "@mui/material";

import { ItemsActions } from "../ItemsActions";
import { AutocompleteServicios } from "../../../pptos/form/AutocompleteServicios";
import {
  iniChangeItemsInside,
  /* iniChangeItemsChecked, */
  iniChangeTotales,
  iniChangeItemsTipoDoc,
} from "../../../../redux/actions/pptosGastos";
/* import { Link } from "react-router-dom";
 */
export const ItemsRow = ({
  item,
  listaTiposDocumentos,
  handleOpenListCompras,
  isEditMode,
}) => {
  const dispatch = useDispatch();

  const { servicesGasto: services } = useSelector((state) => state.general);
  const { detail } = useSelector((state) => state.pptoGasto);
  const {
    items,
    separacion_miles,
    separacion_decimales,
    simbolo,
    reading_mode,
  } = detail;

  const handleChange = (values, target) => {
    if (!values.sourceInfo.event) return false;
    dispatch(iniChangeItemsInside(items, target, values, item));
    dispatch(iniChangeTotales(detail, items));
  };

/*   const handleChangeChecked = (e) => {
    dispatch(iniChangeItemsChecked(items, e.target.checked, item));
  }; */

  const handleTipoDoc = ({ target }, item) => {
    const newIdDoc = target.value;
    dispatch(iniChangeItemsTipoDoc(items, newIdDoc, item));
  };

  return (
    <TableRow className="p-table-rows" key={item.id}>
      {isEditMode && (
        <TableCell className="text-end p-border-separate">
          <ItemsActions
            item={item}
            showAddTitle_={false}
            showAddItem_={false}
          />
        </TableCell>
      )}
      <TableCell align="left" className="sticky left-0 bg-white">
        <AutocompleteServicios itemsOptions={services} item={item} />
        {isEditMode && (
          <div>
            {item.nombre !== "" ? (
              <select
                name="id_tipo_doc"
                style={{
                  border: "1px solid lightgray",
                  borderRadius: "3px",
                  fontSize: "11px",
                }}
                value={item?.id_tipo_doc || ""}
                onChange={(e) => handleTipoDoc(e, item)}
              >
                <option key="" value="">
                  --seleccionar--
                </option>
                {listaTiposDocumentos?.map((it) => {
                  return parseInt(it.id) === parseInt(item.id_tipo_doc) ? (
                    <option key={it.id} value={it.id} selected>
                      {it.nombre}
                    </option>
                  ) : (
                    <option key={it.id} value={it.id}>
                      {it.nombre}
                    </option>
                  );
                })}
              </select>
            ) : (
              ""
            )}
          </div>
        )}
      </TableCell>
      <TableCell align="center">
        <NumberFormat
          className="cantidades-item edit p-fs-12px"
          value={item.cant}
          prefix={""}
          onValueChange={(values, sourceInfo) =>
            handleChange({ ...values, sourceInfo }, "cant")
          }
          disabled={reading_mode}
        />
      </TableCell>
      <TableCell align="center">
        <NumberFormat
          className="cantidades-item p-fs-12px"
          value={item.dias}
          prefix={""}
          onValueChange={(values, sourceInfo) =>
            handleChange({ ...values, sourceInfo }, "dias")
          }
          disabled={reading_mode}
        />
      </TableCell>

      {isEditMode && (
        <>
          <TableCell align="right" className="TextRight">
            <NumberFormat
              className="cantidades-item p-fs-12px"
              value={item.costo_unitario}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
              onValueChange={(values, sourceInfo) =>
                handleChange({ ...values, sourceInfo }, "costo_unitario")
              }
              disabled={reading_mode}
            />
          </TableCell>
          <TableCell align="right" className="p-border-separate ppto subtotal">
            <NumberFormat
              className="cantidades-title p-fs-12px"
              value={item.costo_subtotal}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
            />
            <Tooltip title="valor calculado, no modificable">
              <i className="bi bi-lock p-icon-block"></i>
            </Tooltip>
          </TableCell>
          <TableCell align="right" className="ppto">
            <NumberFormat
              className="cantidades-title p-fs-12px"
              value={item?.total_impuesto || 0}
              displayType={"text"}
              thousandSeparator={separacion_miles}
              decimalSeparator={separacion_decimales}
              prefix={`${simbolo} `}
            />
            <Tooltip title="valor calculado, no modificable">
              <i className="bi bi-lock p-icon-block"></i>
            </Tooltip>
          </TableCell>
        </>
      )}

      <TableCell align="right" className="ppto">
        <NumberFormat
          className="cantidades-title p-fs-12px"
          value={item?.total_a_pagar || 0}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
        />
        <Tooltip title="valor calculado, no modificable">
          <i className="bi bi-lock p-icon-block"></i>
        </Tooltip>
      </TableCell>

      {/* {isEditMode && (
        <>
          <TableCell align="right" className="p-border-separate actual">
            <Link
              to=""
              onClick={() => handleOpenListCompras("item", item)}
              className="p-link-open-dialog"
            >
              <NumberFormat
                className="cantidades-title p-fs-12px"
                value={item.total_gasto_real || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
              <Tooltip title="valor calculado, no modificable">
                <i className="bi bi-lock p-icon-block"></i>
              </Tooltip>
            </Link>
          </TableCell>
          <TableCell align="right" className="p-border-separate actual">
            <Link
              to=""
              onClick={() => handleOpenListCompras("item", item)}
              className="p-link-open-dialog"
            >
              <NumberFormat
                className="cantidades-title p-fs-12px"
                value={item.total_gasto_impuesto || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
              <Tooltip title="valor calculado, no modificable">
                <i className="bi bi-lock p-icon-block"></i>
              </Tooltip>
            </Link>
          </TableCell>
        </>
      )} */}

   {/*    <TableCell align="right" className="p-border-separate actual">
        <Link
          to=""
          onClick={() => handleOpenListCompras("item", item)}
          className="p-link-open-dialog"
        >
          <NumberFormat
            className="cantidades-title p-fs-12px"
            value={item?.total_gasto_final || 0}
            displayType={"text"}
            thousandSeparator={separacion_miles}
            decimalSeparator={separacion_decimales}
            prefix={`${simbolo} `}
          />
          <Tooltip title="valor calculado, no modificable">
            <i className="bi bi-lock p-icon-block"></i>
          </Tooltip>
        </Link>
      </TableCell> */}

      {/* <TableCell align="right" className="p-border-separate actual">
                <NumberFormat
                    className='cantidades-title p-fs-12px'
                    value={item.porcentaje_gasto_real}
                    displayType={'text'}
                    suffix=" %"
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell> */}

      {/* pagos */}
      {/* <TableCell align="right" style={{ backgroundColor: 'white' }}>
                <NumberFormat
                    className='cantidades-title p-fs-12px'
                    value={item?.total_pagado || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell>
            <TableCell align="right" style={{ backgroundColor: 'white' }}>
                <NumberFormat
                    className='cantidades-title p-fs-12px'
                    value={item?.total_por_pagar || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell> */}

      {/* por gastar */}
      {/* <TableCell align="right" className="p-border-separate dif">
        <NumberFormat
          style={{ color: item.total_por_gastar < 0 ? "red" : "" }}
          className="cantidades-title p-fs-12px"
          value={item.total_por_gastar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
        />
        <Tooltip title="valor calculado, no modificable">
          <i className="bi bi-lock p-icon-block"></i>
        </Tooltip>
      </TableCell> */}
      {/* <TableCell align="center" className="p-border-separate dif">
                <NumberFormat
                    style={{ color: item.total_por_gastar < 0 ? 'red' : '' }}
                    className='cantidades-title p-fs-12px'
                    value={item.porcentaje_por_gastar}
                    displayType={'text'}
                    suffix=" %"
                />
                <Tooltip title="valor calculado, no modificable">
                    <i className="bi bi-lock p-icon-block"></i>
                </Tooltip>
            </TableCell> */}

      {/* seleccionar */}
      {/* <TableCell align="center">
        <label htmlFor={`check-select-${item.id}`}>
          <input
            style={{ width: "15px", height: "15px" }}
            type="checkbox"
            id={`check-select-${item.id}`}
            onChange={handleChangeChecked}
          />
        </label>
      </TableCell> */}
    </TableRow>
  );
};
